import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { environment } from '../../../../environments/environment';

const API_URL = environment.apiUrl;

@Injectable()
export class AnnouncementService {

    entity: string;

    constructor(private http: Http) {
    }

    public countOpen() {
        return this.http
            .get(API_URL + '/Announcements/CountAnnouncements/1')
            .map(response => response.json())
            .catch(this.handleError);
    }

    public getTemplates(id: number) {
        return this.http
            .get(API_URL + '/Customers/GetTemplatesById/' + id)
            .map(response => response.json())
            .catch(this.handleError);
    }

    public new(item: any) {
        return this.http
            .post(API_URL + '/Announcements/NewAnnouncement/1', item)
            .map(response => response.json())
            .catch(this.handleError);
    }

    public save(id: number, item: any) {
        return this.http
            .put(API_URL + '/Announcements/MasterDetail/' + id, item)
            .map(response => response.json())
            .catch(this.handleError);
    }

    public delete(item: number): Observable<null> {
        return this.http
            .delete(API_URL + '/Announcements/' + item)
            .map(response => null)
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        console.error('ApiService::handleError', error, this.entity);
        return Observable.throw(error);
    }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/backoffice/announcements/announcement.service.ts